import { Session } from "@auth0/nextjs-auth0";

export const checkIsAdmin = (user: Session): boolean => {
  if (user.user["https://mein.benu.at/roles"][0] === "Admin") {
    return true;
  }
  return false;
};
